var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"45px"}},[(_vm.loading)?_c('img',{attrs:{"src":"/assets/images/loadingimgcar.png","alt":"Loading..."}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }